
import {TokenCredentials} from '../login/tokencredentials';
import { OrderPos, Order } from '../order/order';
import { Article } from '../article/article';
import { Customer } from '../customer/customer';

export class StockSearch {
    credentials: TokenCredentials;

    id : number;
	userid : number;
    
    name : string;
    descr : string;
    priority: number;
    task : string;

    matches : StockSearchMatch[];
    filters : StockSearchFilter[];

    created : Date;
    updated : Date;
}

export class StockSearchMatch {
    id : number;

    field : string;
    comparator : string;
    expression : string;

    created : Date;
    updated : Date;
}

export class StockSearchFilter {
    id : number;
    
    field : string;
    comparator : string;
    expression : string;

    created : Date;
    updated : Date;
}

export class StockSearchRequest {
    orderpos : OrderPos;
    order : Order;
    article : Article;
    customer : Customer;
    quantityQueried : number;
    destinationLocationId : number;
    credentials : TokenCredentials;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock-search.ts